import styled from 'styled-components';

export const fullPageScreenHeaderHeight = `calc(${Styles.layout.checkoutHeaderHeight} + env(safe-area-inset-top))`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  background: ${Styles.color.black};
  width: 100%;
  z-index: ${Styles.zIndex.overlay + 150};
  height: ${fullPageScreenHeaderHeight};
  ${Styles.mobileFullscreen`
    padding-top: env(safe-area-inset-top);
  `}

  ${Styles.desktop`
    position: absolute;
  `}
`;

export const Heading = styled.h1`
  font-size: 1.375rem;
  color: ${Styles.color.white};
  font-family: ${Styles.fontFamily.base};
  margin: 0.75rem auto;
  text-transform: uppercase;
`;
